<template>
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M9 2H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6L9 2z"/>
    <polyline points="9 2 9 6 13 6"/>
    <line x1="8" y1="9" x2="8" y2="12"/>
    <line x1="6.5" y1="10.5" x2="9.5" y2="10.5"/>
  </svg>
</template>
